import { apiClient } from '@app/api';
import { DateTimeStr, buildQueryString } from '@mi-front/core';
import { navigateTo } from '../routing';

export function downloadStationVideo(args: {
  readonly stationId: string;
  readonly from: DateTimeStr;
  readonly to: DateTimeStr;
  readonly filename?: string;
  readonly downloadTs?: boolean;
}) {
  const { stationId, from, to, filename, downloadTs } = args;

  const url = `${apiClient.getApiRoot()}/stations/${stationId}/export/video?${buildQueryString({
    from,
    to,
    access_token: apiClient.getToken(),
    download: '1',
    filename,
    'encoding[outputFormat]': downloadTs ? 'ts' : undefined,
  })}`;

  navigateTo(url);
}
